import React, { useState, useEffect } from 'react'
import './leaveRequest.css'
import RequestForm from './RequestForm'
import { Link } from 'react-router-dom'
import { leaveBalance } from '../../api/leaveApi'
import { useSelector, useDispatch } from 'react-redux'
import { handleBalance } from '../../state/leaveSlice'
import leaveImg from '../../assets/leave_img.png'
import { TfiHandPointLeft, TfiHandPointUp } from "react-icons/tfi";


const LeaveRequest = () => {
    const [tab, setTab] = useState('')
    const {user} = useSelector((state)=> state.user)
    const {balance} = useSelector((state)=> state.leave)
    const dispatch = useDispatch()

    const fetchLeaveRequest = async ()=>{
        try{
            const res = await leaveBalance(user?.token)
            dispatch(handleBalance(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const handleTabToggle = (val) => {
        setTab(val)
    }

    useEffect(()=>{
        fetchLeaveRequest()
    },[])

  return (
    <section className='leave__request'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Leave Request | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Leave Request <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    You can request for a leave by filling the form below or you 
                    can select the type of leave from the tabs and click on it.
                </p>
            </div>
        </div>

        <div className="leave__request-container">
            <div className="leave__request-content">

                <div className="leave__request-tabs">
                    <button 
                    onClick={()=>handleTabToggle('Annual Leave')}
                    className={`leave__request-tab_body ${
                        tab === 'Annual Leave' && 'active'
                    }`}>
                        <h3 className="leave__request-tab_name">
                            Annual Leave
                        </h3>
                        <h2 className="leave__request-tab_title">
                            20 Working Days
                        </h2>
                        <span className="leave__request-tab-total">
                            Total annual leave left: {balance?.map((item)=>item?.annualLeave)}
                        </span>
                    </button>
                    <button onClick={()=>handleTabToggle('Casual Leave')}
                    className={`leave__request-tab_body ${
                        tab === 'Casual Leave' && 'active'
                    }`}>
                        <h3 className="leave__request-tab_name">
                            Casual Leave
                        </h3>
                        <h2 className="leave__request-tab_title">
                            5 Working Days
                        </h2>
                        <span className="leave__request-tab-total">
                            Total annual leave left: {balance?.map((item)=>item?.casualLeave)}
                        </span>
                    </button>
                    <button onClick={()=>handleTabToggle('Other Leave')}
                    className={`leave__request-tab_body ${
                        tab === 'Other Leave' && 'active'
                    }`}>
                        <h3 className="leave__request-tab_name">
                            Other Leaves
                        </h3>
                    </button>
                </div>

                <div className="leave__request-form">
                    {tab ? <RequestForm tab={tab}/>
                    : <div className='leave__request-empty'>
                        <h3 className='leave__request-empty_title'>
                            <TfiHandPointLeft size={20} className='leave__request-empty_icon left' />
                            <TfiHandPointUp size={20} className='leave__request-empty_icon top' />
                            Please select a type of leave to apply
                        </h3>
                        <img src={leaveImg} className='leave__request-img'/>
                    </div>}
                </div>

            </div>
        </div>
    </section>
  )
}

export default LeaveRequest